var React = require('react');

function Union (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.846 0H12.3075V2.46165H14.7693V7.38471H17.2308V2.46165H19.6924V0H22.1539V2.46165H24.6154V7.38471H27.077V9.84659H32V11.0774H0V9.84659H4.92318V7.38471H7.38471V2.46165H9.846V0ZM6.76918 12.308H4.92318V13.5388H6.76918V17.2311H9.23082V18.4615H11.6924V17.2311H14.1538V13.5388H17.846V17.2311H20.3076V18.4615H22.7692V17.2311H25.2306V13.5388H27.077V12.308H25.2306H17.846H14.1538H6.76918Z","fill":"#374151"}));
}

Union.defaultProps = {"width":"32","height":"19","viewBox":"0 0 32 19","fill":"none"};

module.exports = Union;

Union.default = Union;
